const events = {
  'PageHeader/global-filter-brand-update': {
    category: 'filter',
    action: 'Filtering: set Brand'
  },
  'PageHeader/global-filter-weeks-update': {
    category: 'filter',
    action: 'Filtering: set Weeks'
  },
  'PageHeader/global-filter-arrays-update': {
    category: 'filter',
    action: 'Filtering: set Accounts/Items/Stores/States'
  },
  'PageHeader/global-filter-array-update': {
    category: 'filter',
    action: 'Filtering: drilldown'
  },
  'ExportModal/open': {
    category: 'export',
    action: 'Exporting: set export email'
  },
  'ExportModal/selection-set': {
    category: 'export',
    action: 'Exporting: set export type'
  },
  'GroupModal/group-type-set': {
    category: 'group-create',
    action: 'Group Creation: set creating Group Type'
  },
  'GroupModal/item-change': {
    category: 'group-create',
    action: 'Group Creation: set Items for Item group'
  },
  'GroupModal/group-item-change': {
    category: 'group-create',
    action: 'Group Creation: set Accounts/Stores/States group for Store group'
  },
  'GroupModal/group-item-apply': {
    category: 'group-create',
    action: 'Group Creation: set Group item Apply'
  },
  'FavoritesModal/show': {
    category: 'favorite-create',
    action: 'Favorite Creation'
  },
  'CreateEditCampaign/item-select': {
    category: 'campaign-create',
    action: 'Campaign Creation: set Accounts/Stores/States/Items group on creation'
  },
  'CreateEditCampaign/selection-apply': {
    category: 'campaign-create',
    action: 'Campaign Creation: set Campaign item Apply'
  },
  'CreateEditCampaign/details-value-change': {
    category: 'campaign-create',
    action: 'Campaign Creation: set Campaign Details'
  },
  'CreateEditCampaign/create-campaign-finish': {
    category: 'campaign-create',
    action: 'Campaign Created'
  }
};

export default events;
